import Temp from "@/courier/Temp";
export default class KerryExpress extends Temp {
  static CODE = "KRYS";
  API_URL = this._VUE.$API_URL;
  static API = {
    checkSameAddress: "/address/province/same",
    checkCodeAvailable: "/check-code-available",
  };
  static NAMEZONE = {
    BKK_TO_BKK: 1,
    BKK_TO_UPC: 2,
    UPC23_SAME_PROVINCE: 3,
    UPC23_SAME_UPC23: 4,
    UPC23_TO_UPC: 5,
    UPC50_SAME_PROVINCE: 6,
    UPC50_SAME_UPC50: 7,
    UPC50_TO_UPC: 8,
  };
  static NAMESUBZONE = {
    BKK: 1,
    UPC23: 2,
    UPC50: 3,
  };

  constructor() {
    super(KerryExpress.CODE);
  }

  async getZone(item) {
    let type, from, to;
    let special_code = "";
    let cross_price = 0;
    let remote_area = 0;

    // remote_area = super.checkRemoteArea( Number(item.toPostcode) )

    from = super.checkZone(item.fromPostcode);
    to = super.checkZone(item.toPostcode);
    type = await this.checkRateType(item, {from: from, to: to});
    if( item.courierPromotion ){
      if( item.specialCode ){
        special_code = item.specialCode
      }else{
        special_code = await this.checkCodeAvailable({
          from: {
            ...item.from,
            tel: item.senderTel,
          },
          to: item.to,
          parcel: item.parcel,
          listSpecialCode: item.listSpecialCode,
        })
      }
    }
    return {
      rate_type: type,
      rate_remote_area: remote_area,
      cross_price: cross_price,
      special_code: special_code,
    };
  }
  async checkRateType(item, zone) {
    const subZone = this.checkSubZone(item);
    const sameProvince = await this.checkSameProvince(item);
    if (subZone === KerryExpress.NAMESUBZONE.BKK) {
      if (zone.from === zone.to) return KerryExpress.NAMEZONE.BKK_TO_BKK;
      else return KerryExpress.NAMEZONE.BKK_TO_UPC;
    } else if (subZone === KerryExpress.NAMESUBZONE.UPC23) {
      if (sameProvince) return KerryExpress.NAMEZONE.UPC23_SAME_PROVINCE;
      else if (zone.from === zone.to)
        return KerryExpress.NAMEZONE.UPC23_SAME_UPC23;
      else return KerryExpress.NAMEZONE.UPC23_TO_UPC;
    } else {
      if (sameProvince) return KerryExpress.NAMEZONE.UPC50_SAME_PROVINCE;
      else if (zone.from === zone.to)
        return KerryExpress.NAMEZONE.UPC50_SAME_UPC50;
      else return KerryExpress.NAMEZONE.UPC50_TO_UPC;
    }
  }

  checkSubZone(item) {
    const SUBZONE = this.listPostcodeSpecial["KRYS"]["sub-zone"];
    let find = Object.values(SUBZONE).findIndex((postcodes) => {
      return postcodes.find((postcode) => {
        return postcode == item.fromPostcode;
      });
    });
    // +1 เพราะว่า index มันเป็น 0
    return find + 1;
  }

  async checkSameProvince(item) {
    const check = await this._VUE.$http.get(
      this.API_URL + KerryExpress.API.checkSameAddress,
      {
        headers: {
          Token: localStorage.getItem("access_token"),
        },
        params: {
          from_postcode: item.fromPostcode,
          to_postcode: item.toPostcode,
        },
      }
    );

    try {
      const _check = check.data.data;
      if (_check.status === false) throw _check.msg;
      else if (_check.msg === "not within same province") return false;
      else return true;
    } catch (err) {
      console.info(err);
      return false;
    }
  }

  async checkCodeAvailable(item) {
    console.log("checkCodeAvailable", item);
    if (
      item.parcel &&
      ["ENVELOP", "SEALBAGLITE", "SEALBAGA|B", "SEALBAGC", "MINI"].includes(
        item.parcel.key_size
      )
    ) {
      const check = await this._VUE.$http.post(
        this.API_URL + KerryExpress.API.checkCodeAvailable,
        {
          courier_code: "KRYS",
          data: {
            from: item.from,
            to: item.to,
            parcel: item.parcel,
          },
          special_codes: item.listSpecialCode,
          // TODO: ส่ง special code ที่เคยได้ไปใช้บน frontend ทั้งหมดมาด้วย
        },
        {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        }
      );

      try {
        const _check = check.data;
        if (_check.status) return _check.data.special_code;
        return false;
      } catch (err) {
        console.info(err);
        return false;
      }
    }
    return false;
  }

  checkWeight(courierRates, item) {
    item.index = Object.values(courierRates).findIndex((index) => {
      return index.dimension === item.keySize;
    });
    return {
      index: item.index,
    };
  }
}
